import { render, staticRenderFns } from "./settingPay.vue?vue&type=template&id=313676d6&scoped=true&"
import script from "./settingPay.vue?vue&type=script&lang=js&"
export * from "./settingPay.vue?vue&type=script&lang=js&"
import style0 from "./settingPay.vue?vue&type=style&index=0&id=313676d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313676d6",
  null
  
)

export default component.exports